import { useId } from '@floating-ui/react';
import { Popover } from '@hologram-dimension/popover';
import { EmptyState } from 'components';
import { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import { SimKey } from 'types/common';
import { apiDateToDateTime, formatDateTime } from 'utils/dates';
import getNormalizedRelativeDuration from 'utils/dates/getNormalizedRelativeDuration';
import type {
  CustomCellRendererProps,
  CustomCellRendererReturn,
  SimCellRendererProps,
} from '../SimInventoryTableShared';
import styles from './DurationRenderer.module.css';

interface DurationRendererProps extends CustomCellRendererProps<SimsDaoSim, SimCellRendererProps> {}

const DurationRenderer = ({
  value,
  columnValue,
}: DurationRendererProps): CustomCellRendererReturn => {
  const dateValue = value[columnValue as SimKey];

  const id = useId();

  if (
    typeof dateValue !== 'string' ||
    dateValue.length === 0 ||
    dateValue === '0101-01-01T00:00:00Z'
  ) {
    return <EmptyState />;
  }

  return (
    <Popover
      id={id!}
      content={
        <span className={styles.popoverContent}>
          {formatDateTime(dateValue)}
          <br />
          {formatDateTime(dateValue, '12hrlocal')}
        </span>
      }
      className={styles.wrapper}
    >
      {getNormalizedRelativeDuration({ start: apiDateToDateTime(dateValue), top: 1 })}
    </Popover>
  );
};

export default DurationRenderer;
